var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('blockquote',[_vm._v(" “"+_vm._s(_vm.quote)+"” "),_c('footer',[_c('small',[_c('em',[_vm._v("—"+_vm._s(_vm.author))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }